module.exports = __webpack_public_path__ + "site-80.jpg?06d5e20c4105d5dc883a16e485dc49b0";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-80.jpg
 ** module id = 192
 ** module chunks = 0
 **/